"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var country_code_to_dialing_code_1 = __importDefault(require("./data/country-code-to-dialing-code"));
exports.countryCodeToDialingCode = country_code_to_dialing_code_1.default;
var dialing_code_to_country_code_1 = __importDefault(require("./data/dialing-code-to-country-code"));
exports.dialingCodeToCountryCode = dialing_code_to_country_code_1.default;
var index_1 = __importDefault(require("./decorators/index"));
var detect_country_1 = __importDefault(require("./detect-country"));
exports.default = {
    decorate: function (phoneNumber, countryCode, extensionConfig) {
        if (extensionConfig === void 0) { extensionConfig = { decoratedDelimiter: " ext. ", delimiter: "x" }; }
        var country;
        if (phoneNumber.charAt(0) !== "+" && countryCode && country_code_to_dialing_code_1.default[countryCode]) {
            var dialingCode = country_code_to_dialing_code_1.default[countryCode];
            phoneNumber = "" + dialingCode + phoneNumber;
            country = {
                countryCode: countryCode,
                dialingCode: dialingCode,
            };
        }
        else {
            country = detect_country_1.default(phoneNumber);
        }
        var extDelimiterRegex = new RegExp(extensionConfig.decoratedDelimiter, "g");
        var normalizedNumber = phoneNumber
            .replace(extDelimiterRegex, "x")
            .replace(new RegExp("[^\\d" + extensionConfig.delimiter + ",]", "g"), "");
        if (!country || !index_1.default[country.countryCode]) {
            return index_1.default.unknown.decorate(normalizedNumber, extensionConfig);
        }
        return index_1.default[country.countryCode].decorate(normalizedNumber, extensionConfig);
    },
};
//# sourceMappingURL=index.js.map